/* ============================================================
   AUTOMAT — comportamento compartilhado das landing pages.
   Toda inicialização é defensiva: só roda se o elemento existir,
   então as duas páginas (Empresas e Agências) usam o mesmo bundle.
   ============================================================ */

const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/* ---------- Barra de progresso ---------- */
const progress = document.getElementById("progress");
if (progress) {
  const updateProgress = () => {
    const h = document.documentElement;
    const max = h.scrollHeight - h.clientHeight;
    progress.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + "%";
  };
  window.addEventListener("scroll", updateProgress, { passive: true });
  updateProgress();
}

/* ---------- Navbar: glass ao rolar ---------- */
const nav = document.getElementById("nav");
if (nav) {
  const onScroll = () => nav.classList.toggle("scrolled", window.scrollY > 12);
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}

/* ---------- Menu mobile ---------- */
const burger = document.getElementById("burger");
const mobileMenu = document.getElementById("mobileMenu");
if (burger && mobileMenu) {
  burger.addEventListener("click", () => {
    const open = mobileMenu.classList.toggle("open");
    burger.setAttribute("aria-expanded", String(open));
    document.body.style.overflow = open ? "hidden" : "";
  });
  mobileMenu.querySelectorAll("a").forEach((a) =>
    a.addEventListener("click", () => {
      mobileMenu.classList.remove("open");
      burger.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    })
  );
}

/* ---------- Tickers: conteúdo declarado em data-ticker ----------
   <div class="ticker-track" data-ticker='["a","b"]' data-ticker-style="star|seg|cta"></div>
   Duplica o conteúdo para o translateX(-100%) emendar sem salto. */
const star =
  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6L12 0z"/></svg>';
const tickerRenderers = {
  star: (t) => `<span class="ticker-item">${t} ${star}</span>`,
  seg: (s) => `<span class="seg-item">${s}<span class="sep">✦</span></span>`,
  cta: (t) => `<span class="cta-bg-item">${t} —</span>`,
};
document.querySelectorAll("[data-ticker]").forEach((track) => {
  let items;
  try {
    items = JSON.parse(track.dataset.ticker);
  } catch {
    return;
  }
  const render = tickerRenderers[track.dataset.tickerStyle] || tickerRenderers.star;
  const copies = Number(track.dataset.tickerCopies || 3);
  track.innerHTML = items.map(render).join("").repeat(copies);
  const clone = track.cloneNode(true);
  clone.removeAttribute("data-ticker");
  clone.setAttribute("aria-hidden", "true");
  track.parentElement.appendChild(clone);
});

/* ---------- Scroll reveal ---------- */
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add("in");
        observer.unobserve(e.target);
      }
    });
  },
  { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
);
document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

/* ---------- Cursor glow no hero (lerp suave) ---------- */
const hero = document.getElementById("hero");
const glow = document.getElementById("cursorGlow");
if (hero && glow && !reduced && window.matchMedia("(pointer: fine)").matches) {
  let mx = 0, my = 0, gx = 0, gy = 0, raf = null;
  const loop = () => {
    gx += (mx - gx) * 0.12;
    gy += (my - gy) * 0.12;
    glow.style.left = gx + "px";
    glow.style.top = gy + "px";
    if (Math.abs(mx - gx) > 0.5 || Math.abs(my - gy) > 0.5) {
      raf = requestAnimationFrame(loop);
    } else {
      raf = null;
    }
  };
  hero.addEventListener("mousemove", (ev) => {
    const r = hero.getBoundingClientRect();
    mx = ev.clientX - r.left;
    my = ev.clientY - r.top;
    if (!raf) raf = requestAnimationFrame(loop);
  });
}

/* ---------- Chat ao vivo: cenários rotativos (só na pág. Empresas) ---------- */
const chatBody = document.getElementById("chatBody");
if (chatBody) {
  const scenarios = [
    {
      q: "O que eu devo fazer hoje?",
      a: 'Priorize: <strong>2 orçamentos vencendo</strong>, <strong>5 leads quentes sem resposta</strong> e a cliente Márcia, que reclamou ontem e ainda não teve retorno.<span class="src">IA Central · análise das últimas 24h</span>',
    },
    {
      q: "Onde estou perdendo vendas?",
      a: '<strong>62% dos leads</strong> que pedem orçamento não recebem follow-up. Recuperar metade disso significa <strong>~R$ 12 mil/mês</strong>.<span class="src">IA Central · funil dos últimos 30 dias</span>',
    },
    {
      q: "Quais clientes estão em risco?",
      a: '<strong>7 clientes recorrentes</strong> sem comprar há mais de 60 dias. Três deles respondem bem a ofertas — quer que eu prepare uma campanha de reativação pra você revisar?<span class="src">IA Central · CRM + histórico de compras</span>',
    },
    {
      q: "Como está a agenda da semana?",
      a: '<strong>83% dos horários preenchidos</strong>. Quinta à tarde está vazia — posso oferecer os horários pros leads que pediram orçamento essa semana.<span class="src">IA Central · Agenda Inteligente</span>',
    },
    {
      q: "Como estão minhas campanhas?",
      a: '<strong>R$ 1.980 investidos</strong> nos últimos 7 dias, CPL de <strong>R$ 14,20</strong>. O conjunto de remarketing está 2x mais caro que a média — vale realocar a verba.<span class="src">IA Central · Gestor de Tráfego</span>',
    },
  ];

  if (reduced) {
    const s = scenarios[0];
    chatBody.innerHTML =
      '<div class="msg user">' + s.q + "</div>" + '<div class="msg bot">' + s.a + "</div>";
  } else {
    let si = 0;
    const el = (cls, html) => {
      const d = document.createElement("div");
      d.className = cls;
      d.innerHTML = html;
      return d;
    };
    const playScenario = () => {
      const s = scenarios[si];
      chatBody.innerHTML = "";
      chatBody.appendChild(el("msg user", s.q));
      setTimeout(() => {
        const t = el("typing", "<i></i><i></i><i></i>");
        chatBody.appendChild(t);
        setTimeout(() => {
          t.remove();
          chatBody.appendChild(el("msg bot", s.a));
          setTimeout(() => {
            si = (si + 1) % scenarios.length;
            playScenario();
          }, 5200);
        }, 1500);
      }, 900);
    };
    const chatObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          playScenario();
          chatObserver.disconnect();
        }
      },
      { threshold: 0.35 }
    );
    chatObserver.observe(chatBody);
  }
}

/* ---------- FAQ accordion ---------- */
document.querySelectorAll(".faq-item").forEach((item) => {
  const btn = item.querySelector(".faq-q");
  const panel = item.querySelector(".faq-a");
  if (!btn || !panel) return;
  btn.addEventListener("click", () => {
    const isOpen = item.classList.contains("open");
    document.querySelectorAll(".faq-item.open").forEach((o) => {
      o.classList.remove("open");
      o.querySelector(".faq-q").setAttribute("aria-expanded", "false");
      o.querySelector(".faq-a").style.maxHeight = "0";
    });
    if (!isOpen) {
      item.classList.add("open");
      btn.setAttribute("aria-expanded", "true");
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
});
